import api from './api';

const base = '/expenses';

export const burnExpenseService = {
  getCategories: (params = {}) => api.get(`${base}/categories`, { params }).then(r => r.data),
  createCategory: (data) => api.post(`${base}/categories`, data).then(r => r.data),
  getCategoryById: (id) => api.get(`${base}/categories/${id}`).then(r => r.data),
  updateCategory: (id, data) => api.put(`${base}/categories/${id}`, data).then(r => r.data),
  deleteCategory: (id) => api.delete(`${base}/categories/${id}`).then(r => r.data),

  getEntries: (params = {}) => api.get(`${base}/entries`, { params }).then(r => r.data),
  createEntry: (data) => api.post(`${base}/entries`, data).then(r => r.data),
  getEntryById: (id) => api.get(`${base}/entries/${id}`).then(r => r.data),
  updateEntry: (id, data) => api.put(`${base}/entries/${id}`, data).then(r => r.data),
  deleteEntry: (id) => api.delete(`${base}/entries/${id}`).then(r => r.data),
  approveEntry: (id) => api.put(`${base}/entries/${id}/approve`).then(r => r.data),

  getBurnSummary: (params = {}) => api.get(`${base}/burn-summary`, { params }).then(r => r.data),
  getBurnTrend: (params = {}) => api.get(`${base}/burn-trend`, { params }).then(r => r.data),

  // Financial Year Budget (Indian FY April–March)
  createFinancialYearBudget: (data) => api.post(`${base}/financial-year-budget`, data).then(r => r.data),
  getFinancialYearBudgets: (params = {}) => api.get(`${base}/financial-year-budget`, { params }).then(r => r.data),
  approveFinancialYearBudget: (id) => api.put(`${base}/financial-year-budget/${id}/approve`).then(r => r.data),
  freezeFinancialYearBudget: (id) => api.put(`${base}/financial-year-budget/${id}/freeze`).then(r => r.data),
  unfreezeFinancialYearBudget: (id) => api.put(`${base}/financial-year-budget/${id}/unfreeze`).then(r => r.data),
  createNextFinancialYearBudgetRevision: (id) => api.post(`${base}/financial-year-budget/${id}/next-revision`).then(r => r.data),
  getFinancialYearBudgetSummary: (id) => api.get(`${base}/financial-year-budget/${id}/summary`).then(r => r.data),
  upsertBudgetLines: (id, lines) => api.post(`${base}/financial-year-budget/${id}/lines`, { lines }).then(r => r.data),
  getBudgetLines: (id) => api.get(`${base}/financial-year-budget/${id}/lines`).then(r => r.data),
  getBudgetVsActual: (params = {}) => api.get(`${base}/budget-vs-actual`, { params }).then(r => r.data)
};

export default burnExpenseService;
